<template>
    <div style="">
        <p>You will be charged ${{today_amount}} when you click on the button below,
            and have immediate access to Content Chimera.</p>
        <div id="card-element" style="height:50px;margin-top:30px;"></div>
        <div style="margin-top:30px;">
            Buying for this organization:
            <el-select filterable v-model="selected_org_id" style="width:400px;">
                <el-option
                        v-for="org in org_data"
                        :key="org.id"
                        :label="org.name"
                        :value="org.id">
                </el-option>
            </el-select>
        </div>
        <el-button :disable="isDisabled" style="margin-top:30px;" @click="submit()" type="primary">Buy Now</el-button>
        <img v-if="isDisabled" style="height:40px" src="/images/spinning-progress.gif" />
        <div v-if="message" style="margin-top:20px;background-color:palevioletred;color:white;padding:10px;">{{message}}</div>
    </div>
    
</template>


<script>
    export default {
        props: ['today_amount','org_id_from_blade','product_name','plan_name'],
        name: "PaymentMethod",
        data() {
            return {
                stripe: null,
                cardElement: null,
                style: {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                },
                org_data: null,
                selected_org_id: null,
                message: "",
                isDisabled: false,
            }
        },
        methods: {
            async submit() {
                this.isDisabled = true
                console.log()
                const data = await axios.get('/api/stripe')
                console.log('from /api/stripe:')
                console.log(data.data)

                const { setupIntent, error } = await this.stripe.confirmCardSetup(
                    data.data.intent.client_secret, {
                        payment_method: {
                            card: this.cardElement,
                        }
                    }
                );
                if (error) {
                    // Display "error.message" to the user...
                    console.log(error)
                    this.isDisabled = false
                } else {
                    // The card has been verified successfully...
                    console.log(setupIntent)

                    axios.post('/api/buy/' + this.selected_org_id, {
                        product_name: this.product_name,
                        plan_name: this.plan_name,
                        payment_method_id: setupIntent.payment_method
                    }).then(response => {
                        console.log(response)
                        if (response.data==='success') {
                            console.log('finished adding the subscription')
                            window.location.href = "/pay/thanks"
                        } else {
                            this.message = response.data
                            this.isDisabled = false
                        }
                    }).catch(error => {
                        console.log('could not add the subscription')
                        console.log(error.response)
                    });
                }
            }
        },
        mounted() {
            this.stripe = Stripe(process.env.MIX_STRIPE_KEY);
            const elements = this.stripe.elements();
            this.cardElement = elements.create('card',{style: this.style});
            this.cardElement.mount('#card-element');
            axios.get("/api/orgs")
                .then(response => {
                    console.log(response.data)
                    this.org_data = response.data
                    if (this.org_id_from_blade) {
                        this.selected_org_id = parseInt(this.org_id_from_blade,10)
                    } else {
                        this.selected_org_id = this.org_data[0].id
                    }
                })
                .catch(error => {
                    console.log("Could not get org list")
                })
        }
    }
</script>

<style scoped>

</style>